import { createClient } from 'contentful';
import loadConfiguration from 'ggApp/utils/configuration';

// Limit timeout for Contentful – if it fails, we are not going to wait
// default 30s to render the page on SSR.
// TODO: try to load on the client again?
const contentfulTimeout = 5000;
// Turn retries off for SSR – otherwise the request promise will be never
// resoled. Contentful will try to fetch with exponential backoff
const contentfulRetryOnError = false;

const {
    CONTENTFUL_SPACE_ID: contentfulSpaceId,
    CONTENTFUL_DELIVERY_ACCESS_TOKEN: contentfulAccessToken,
    G_PAGES_CONTENTFUL_API_HOST: gPagesContentfulApiHost,
    G_PAGES_CONTENTFUL_SPACE_ID: gPagesContentfulSpaceId,
    G_PAGES_CONTENTFUL_DELIVERY_ACCESS_TOKEN: gPagesContentfulAccessToken,
} = loadConfiguration();

const defaultSettings = {
    timeout: contentfulTimeout,
    retryOnError: contentfulRetryOnError,
};

const retrySettings = {
    timeout: 10000,
    retryOnError: contentfulRetryOnError,
};

export const mainClient = createClient({
    space: contentfulSpaceId,
    accessToken: contentfulAccessToken,
    ...defaultSettings,
});

export const gPageClient = createClient({
    host: gPagesContentfulApiHost,
    space: gPagesContentfulSpaceId,
    accessToken: gPagesContentfulAccessToken,
    ...defaultSettings,
});

export const mainLongerTimeoutClient = createClient({
    space: contentfulSpaceId,
    accessToken: contentfulAccessToken,
    ...retrySettings,
});

export const gPageLongerTimeoutClient = createClient({
    host: gPagesContentfulApiHost,
    space: gPagesContentfulSpaceId,
    accessToken: gPagesContentfulAccessToken,
    ...retrySettings,
});
